(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('TechnicienDeleteController',TechnicienDeleteController);

    TechnicienDeleteController.$inject = ['$uibModalInstance', 'entity', 'Technicien'];

    function TechnicienDeleteController($uibModalInstance, entity, Technicien) {
        var vm = this;

        vm.technicien = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Technicien.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
